import { Box, Tab, Tabs } from "@mui/material";
import React from "react";

const TextSlider = ({ activeTab, handleTabChange, tab1 = "", tab2 = "" }) => {
  return (
    <Box
      sx={{
        borderRadius: "50px",
        backgroundColor: "#F6F9FF",
        padding: "4px",
        width: "fit-content",
        minHeight: "40px",
      }}
    >
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        TabIndicatorProps={{
          style: { display: "none", minHeight: "40px" },
        }}
        sx={{
          minHeight: "32px !important",
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: 600,
            padding: "6px 16px",
            borderRadius: "50px",
            transition: "all 0.3s ease",
            minHeight: "32px !important",
            "&.Mui-selected": {
              color: "#0D2EED",
              backgroundColor: "#DAEAFF",
              boxShadow: "0px 0px 4px 0px #0000001A",
            },
          },
        }}
      >
        <Tab label={tab1} />
        <Tab label={tab2} />
      </Tabs>
    </Box>
  );
};

export default TextSlider;